import { Address, erc4626Abi } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const mainnetAddress: Address =
  "0x221B2D9aD7B994861Af3f4c8A80c86C4aa86Bf53" as Address

const testnetAddress: Address = "0x44c8665fe06425Ca801f38DE39e71f61185E90AE"

const address = IS_MEZO_MAINNET ? mainnetAddress : testnetAddress

const abi = erc4626Abi

export default {
  address,
  abi,
}
